// Module
var code = `<div class="container">

  <form class="form-signin" method="post" ng-submit="login()" name="loginForm">
    <span class="brand-icon"></span>
    <div class="form-group has-feedback">
            <input class="form-control input-lg" type="text" name="email" ng-model="user.email" placeholder="Email" required autofocus>
          </div>
          <div class="form-group has-feedback">
            <input class="form-control input-lg" type="password" name="password" ng-model="user.password" placeholder="Password" required>
          </div>
          <button type="submit" ng-disabled="loginForm.\$invalid" class="btn btn-lg  btn-block btn-success">Log in</button>
          <span id="login_errors">{{error}}</span>
  </form>

</div>`;
// Exports
module.exports = code;